import { useState } from 'react'

import { 
    ITableContainer, ITableHeader, ITableContent, 
    ITableRow, ITableRowCheckBox 
} from './types'

import { Container } from '@ui/container'
import { IconCheck } from '@img/icons'

import css from './index.module.scss'


/** Основной контенер таблицы */
export const TableContainer = ({ children }: ITableContainer) => {
    return <>
        <Container className={css['table_container']}>
            {children}
        </Container>
    </>
}

/** Заголовок таблицы */
export const TableHeader = ({ paddingLeft, paddingRight, classNameContainer, classNameContent, children }: ITableHeader) => {

    /** Изменяемые стили компоненты */
    const contentStyles: React.CSSProperties = {
        paddingLeft: paddingLeft,
        paddingRight: paddingRight,
    }


    return <>
        <div className={`${css['table_header']} ${classNameContainer}`.trim()}>
            <div className={`${css['table_header__content']} ${classNameContent}`.trim()} style={contentStyles}>
                {children}
            </div>
        </div>
    </>
}

/** Тело таблицы под строки */
export const TableContent = ({ gap, minHeight, isScrollVertical = true, isScrollHorizontal = false, children }: ITableContent) => {

    /** Изменяемые стили компоненты */
    const componentStyles: React.CSSProperties = {
        gap: gap,
        minHeight: minHeight,
        overflowY: isScrollVertical ? 'scroll' : 'hidden',
        overflowX: isScrollHorizontal ? 'scroll' : 'hidden',
    }

    return <>
        <div className={`${css['table_content']}`} style={componentStyles}>
            {children}
        </div>
    </>
}

/** Строка таблицы классическая */
export const TableRow = ({ className, children, background, padding, onClick }: ITableRow) => {
    const styleMain: React.CSSProperties = {
        background: background,
        padding: padding,
    }

    return <>
        <div className={`${css['table_row']} ${className || ''}`.trim()} style={styleMain} onClick={onClick}>
            {children}
        </div>
    </>
}

/** Строка таблицы в виде CheckBox */
export const TableRowCheckBox = ({ headerWidth, isSelected, className, header, children, onClick }: ITableRowCheckBox) => {
    const [isHovered, setIsHovered] = useState(false)

    /** Изменяемые стили заголовка компоненты */
    const headerStyles: React.CSSProperties = {
        width: headerWidth,
    }

    const rowClassName = `${css['table_row']} ${css['table_row_checkbox']} ${(isSelected || isHovered) ? css['table_row_checkbox_active'] : ''}`.trim()


    return <>
        <div
            className={rowClassName}
            onClick={onClick}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            <div className={css['header']} style={headerStyles}>
                {isSelected || isHovered ? <IconCheck /> : header}
            </div>

            <div className={`${css['content']} ${className || ''}`.trim()}>{children}</div>
        </div>
    </>
}